<template>
  <div class="r-form">
    <numbers
      class="r-form__item mb-3"
      :value="recipients"
      @input="update({ recipients: $event, include, exclude })"
    />

    <data-bases
      :need_show_range="need_show_range"
      :range_from_one="range_from_one"
      type="include"
      class="r-form__item mb-3"
      :value="include"
      @input="update({ include: $event })"
    />

    <data-bases
      :need_show_range="need_show_range"
      :range_from_one="range_from_one"
      type="exclude"
      class="r-form__item mb-3"
      :value="exclude"
      @input="update({ exclude: $event })"
    />
  </div>
</template>

<script>
  import DataBases from './input-recipients-databases';
  import Numbers from './input-recipients-numbers';
  import get from 'lodash-es/get';
  import isEqual from 'lodash-es/isEqual';
  import cloneDeep from 'lodash-es/cloneDeep';
  import uniq from 'lodash-es/uniq';
  import { replaceNotNumber } from '@shared/helpers/replace';

  export default {
    components: { DataBases, Numbers },
    props: {
      value: {
        type: Object,
        default: () => ({})
      },
      need_show_range: {
        type: Boolean,
        default: true
      },
      range_from_one: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      recipients: [],
      include: [],
      exclude: []
    }),

    watch: {
      value: {
        handler: function (value) {
          const val = cloneDeep(value);
          this.recipients = uniq(get(val, 'recipients', [])).splice(0, 100);
          this.include = get(val, 'include', []);
          this.exclude = get(val, 'exclude', []);
          this.update({
            recipients: this.recipients,
            include: this.include,
            exclude: this.exclude
          });
        },
        immediate: true,
        deep: true
      }
    },

    methods: {
      update(e) {
        const recipients = uniq(get(e, 'recipients', []).map((i) => replaceNotNumber(i)));
        const include = get(e, 'include', []);
        const exclude = get(e, 'exclude', []);

        const current = {
          recipients,
          include,
          exclude
        };

        if (!isEqual(current, this.value)) {
          this.$emit('input', current);
        }
      }
    }
  };
</script>

<style lang="scss">
  .r-form {
    &__item {
      width: calc(100% - 14px);

      &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:hover {
          text-decoration: none;
        }

        label,
        span {
          margin-bottom: 0;

          &:hover {
            cursor: pointer;
          }
        }

        label {
          font-weight: 700;
          font-size: 14px;
          color: $blue-grey-dark;
        }

        span {
          color: $blue-grey-light;

          &:after {
            content: '\F11F';
            transform: rotate(0);
            display: inline-block;
            font-family: Ionicons;
            speak: none;
            font-style: normal;
            font-weight: 400;
            font-variant: normal;
            text-transform: none;
            text-rendering: optimizeLegibility;
            line-height: 1;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            vertical-align: -0.225em;
            text-align: center;

            font-size: 22px;
            margin-left: 5px;
            transition: transform 0.3s;
          }
        }

        &--show {
          span:after {
            transform: rotate(90deg);
          }
        }
      }
    }
  }
</style>
